import {environment} from "../environments/environment";
export const colors = {
  "red" : "#E4421C",
  "yellow" : "#DAD30F",
  "green" : "#01BC85"
}

export const roles : {[key: string] : string} = {
  "ROLE_ADMIN" : "Admin",
  "ROLE_USER" : "User"
}

export enum monitorStatus {
  UP,
  SOFT_DOWN,
  HARD_DOWN
}

export const monitorStatuses = {
  [monitorStatus.UP]: "Up",
  [monitorStatus.SOFT_DOWN]: "Down Soft",
  [monitorStatus.HARD_DOWN]: "Down Hard"
}

export const backendURL = environment.backendURL;
